const providerContractDocumentStatus = Object.freeze({
  Pending: 1,
  Submitted: 2,
  Approved: 3,
  Denied: 4,
  ConditionalApproved: 5,
  ReplacementRequest: 6,
});

export const providerContractDocumentStatusColor = Object.freeze({
  [providerContractDocumentStatus.Pending]: 'secondary-44',
  [providerContractDocumentStatus.Submitted]: 'yellow',
  [providerContractDocumentStatus.Approved]: 'green-light',
  [providerContractDocumentStatus.Denied]: 'brown',
  [providerContractDocumentStatus.ConditionalApproved]: 'orange-light',
  [providerContractDocumentStatus.ReplacementRequest]: 'violet',
});

export default providerContractDocumentStatus;
